import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ISuccessSingleResponse } from '@shared/models/success-single-response';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import {
  INotificationRequest,
  INotification,
  INotificationsResponse,
} from '../models/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private baseUrl: string = environment.SMART_API_URL;
  private readonly http: HttpClient = inject(HttpClient);

  private notificationSubject: BehaviorSubject<null> = new BehaviorSubject<null>(
    null
  );
  public notification$: Observable<null> = this.notificationSubject.asObservable();

  getNotifications(): Observable<ISuccessSingleResponse<INotificationsResponse>> {
    const getNotificationsUrl: string = `${this.baseUrl}notifications/all`;
    const response: Observable<ISuccessSingleResponse<INotificationsResponse>> =
      this.http.get<ISuccessSingleResponse<INotificationsResponse>>(getNotificationsUrl);

    return response;
  }

  createNotification(
    notification: INotificationRequest
  ): Observable<ISuccessSingleResponse<INotification>> {
    const createNotificationUrl: string = `${this.baseUrl}notifications`;
    const response: Observable<ISuccessSingleResponse<INotification>> = this.http
      .post<ISuccessSingleResponse<INotification>>(createNotificationUrl, notification)
      .pipe(tap(() => this.notificationSubject.next(null)));

    return response;
  }

  updateNotification(
    notificationId: number,
    notification: INotificationRequest
  ): Observable<ISuccessSingleResponse<INotification>> {
    const updateNotificationUrl: string = `${this.baseUrl}notifications/${notificationId}`;
    const response: Observable<ISuccessSingleResponse<INotification>> = this.http
      .patch<ISuccessSingleResponse<INotification>>(updateNotificationUrl, notification)
      .pipe(tap(() => this.notificationSubject.next(null)));

    return response;
  }

  updateNotificationStatus(
    notificationId: number,
    isActive: boolean
  ): Observable<ISuccessSingleResponse<INotification>> {
    const updateStatusUrl: string = `${this.baseUrl}notifications/${notificationId}/status`;
    const response: Observable<ISuccessSingleResponse<INotification>> = this.http
      .patch<ISuccessSingleResponse<INotification>>(updateStatusUrl, { active: isActive })
      .pipe(tap(() => this.notificationSubject.next(null)));

    return response;
  }

  deleteNotification(
    notificationId: number
  ): Observable<ISuccessSingleResponse<INotification>> {
    const deleteNotificationUrl: string = `${this.baseUrl}notifications/${notificationId}`;
    const response: Observable<ISuccessSingleResponse<INotification>> = this.http
      .delete<ISuccessSingleResponse<INotification>>(deleteNotificationUrl)
      .pipe(tap(() => this.notificationSubject.next(null)));

    return response;
  }
}